export default "__VITE_ASSET__9m$tckQk__"